/** @format */

import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import CardWrap from '../Common/CardWrap';
import { tenantService } from '../../Services/tenant.service';
import UsersTab from '../Tab/UsersTab';
import StoresTab from '../Tab/StoresTab';
import { useTranslation } from 'react-i18next';
import { apiUrl } from '../../Config/Url';
import PartnersTab from '../Tab/PartnersTab';
import ItemGroupTab from '../Tab/ItemGroupTab';
import CertificateTab from '../Tab/CertificatesTab';
import TeantSettingTab from '../Tab/TeantSettingTab';
import { GlobalContext } from '../../Contexts/GlobalContextProvider';
import { AuthContext } from '../../Contexts/AuthContext';
import PosTab from '../Tab/PosTab';
import { Tabs, Tab } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import SpinnerLoading from '../Common/SpinnerLoading';
import logo from '../../Images/logo2.png';
import * as dateHelper from '../../Helpers/DateHelper';
import LogoUpdate from './LogoUpdate';
import LogoDelete from './LogoDelete';
import { roles } from '../../Config/Roles';
import PaymentMethodTab from '../Tab/PaymentMethodTab/PaymentMethodTab';

const TenantDetail = props => {
	const { updateLocTenant, updateLocName, locTab, updateLocTab, updateLocKey } =
		useContext(GlobalContext);
	const { roleId } = useContext(AuthContext);
	const { master, admin, support, owner } = roles;
	const [key, setKey] = useState('users');
	const { t: translator } = useTranslation();
	const [showLogoUpdate, setShowLogoUpdate] = useState(false);
	const [showDeleteLogo, setShowDeleteLogo] = useState(false);
	const [update, setUpdate] = useState(new Date());

	const { register, handleSubmit, errors } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	const handleHideLogoModal = () => setShowLogoUpdate(false);
	const handleHideDeleteLogo = () => setShowDeleteLogo(false);

	let id = props.match.params.tenantId;
	const history = useHistory();

	const initialState = {
		name: '',
		code: '',
		owner: '',
		taxNumber: '',
		street: '',
		streetNumber: '',
		streetNumberExtension: '',
		city: '',
		countryId: '',
		postalNumber: '',
		iban: '',
		fiscalObligation: true,
		taxObligation: '',
		taxNote: '',
		isDeleted: false,
		isSuspended: false,
		suspensionNote: '',
		logoImage: '',
		lastUpdated: '',
	};

	const [tenant, setTenant] = useState(initialState);
	const [showSuspensionModal, setShowSuspensionModal] = useState(false);
	const [showActivationModal, setShowActivationModal] = useState(false);
	const [showFiscalModal, setShowFiscalModal] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getTenantById();

		if (locTab != null && locTab != 0) {
			setKey(locTab);
		} else {
			setKey('users');
			updateLocTab('users');
		}

		updateLocTenant(id);
		updateLocKey(id);
		updateLocName('tenants');
	}, [id, update]);

	const handleCancel = () => {
		history.push('/tenants');
	};

	const getTenantById = () => {
		tenantService
			.getById(id)
			.then(res => {
				setTenant(res.data);
				setIsLoading(false);
			})
			.catch(err => history.push('/error-page/401'));
	};

	const updateTenant = () => {
		history.push('/update-tenant/' + id);
	};

	const handleActivate = () => {
		tenantService
			.activate(id)
			.then(res => getTenantById())
			.catch(err => console.log(err));
		setShowActivationModal(false);
	};

	const handleFiscal = () => {
		tenantService
			.fiscal(tenant.taxNumber)
			.then(res => console.log(res))
			.catch(err => console.log(err));
		setShowFiscalModal(false);
	};

	const handleSuspend = () => {
		tenantService
			.suspend(id, !tenant.isSuspended, tenant.suspensionNote)
			.then(res => getTenantById())
			.catch(err => console.log(err));

		setShowSuspensionModal(false);
	};
	const handleInputChange = event => {
		const { name, value } = event.target;
		setTenant({ ...tenant, [name]: value });
	};

	return (
		<CardWrap subtitle={translator('Tenants-TenantDetail-Subtitle')}>
			<div className='row pl-0'>
				<div className='col-lg-3'>
					{isLoading && (
						<div className='dashboard-card-spinner'>
							<SpinnerLoading />
						</div>
					)}

					{!isLoading && (
						<div className='custom-card m-2'>
							<div className='custom-card-header'>
								<span className='edit-logo'>
									<i
										className='icon icon-edit'
										title={translator('Update-Logo')}
										onClick={() => setShowLogoUpdate(true)}></i>
									&nbsp;&nbsp;
									{tenant.logoImage != null && (
										<i
											className='icon icon-trash text-danger'
											title={translator('Remove-Logo')}
											onClick={() => setShowDeleteLogo(true)}></i>
									)}
								</span>
								<center>
									<img
										src={tenant.logoImage ? tenant.logoImage : logo}
										className='tenant-image'
									/>
								</center>
								<h3 className=' logo-h3'>
									{tenant.name.length >= 45
										? `${tenant.name.substring(0, 45)}...`
										: tenant.name}{' '}
									{[master, admin, support, owner].includes(Number(roleId)) && (
										<span className='button-edit'>
											{' '}
											<i
												title={translator('Icon-Update-Tenant')}
												onClick={updateTenant}
												className='icon icon-edit'>
												{' '}
											</i>
										</span>
									)}
								</h3>
								<span className='custom-card-subtitle'>
									<strong>{translator('Tenant-TenantDetail-OIB')}:</strong>{' '}
									{tenant.taxNumber}
								</span>
								<hr />
							</div>
							<div className='custom-card-body'>
								<p>
									<strong>{translator('Tenant-TenantDetail-Owner')}:</strong>{' '}
									{tenant.owner}
								</p>
								<p>
									<span>
										<strong>{translator('Tenant-TenantDetail-Street')}:</strong>{' '}
										{tenant.street.length >= 40
											? `${tenant.street.substring(0, 40)}...`
											: tenant.street}
										{tenant.streetNumber}
										{tenant.streetNumberExtension}
									</span>
									<br />
									<span>
										<strong>{translator('Tenant-TenantDetail-City')}:</strong>{' '}
										{tenant.postalNumber}, {tenant.city}
									</span>
									<br />
									<span>
										<strong>
											{translator('Tenant-TenantDetail-TaxNote')}:
										</strong>{' '}
										{tenant.taxNote}
									</span>
								</p>
								<hr />
								<p>
									<label className='labelCont'>
										<input
											type='checkbox'
											name='fiscalObligation'
											checked={tenant.fiscalObligation}
										/>
										<span className='checkmark'></span>
									</label>
									<span className='Data'>
										{translator('Tenant-TenantDetail-ObligorOfFiscalization')}
									</span>

									<br />
									<label className='labelCont'>
										<input
											type='checkbox'
											name='fiscalObligation'
											checked={tenant.taxObligation}
										/>
										<span className='checkmark'></span>
									</label>
									<span className='Data'>
										{translator('Tenant-TenantDetail-TaxLiability')}
									</span>

									<br />
								</p>
							</div>
							{[master, admin, support].includes(Number(roleId)) && (
								<div
									class='custom-card-footer'
									style={{ borderTop: '1px solid #ccc', paddingTop: '22px' }}>
									<label class='control-label'>
										* {translator('DangerArea')}
									</label>
									{!tenant.isDeleted ? (
										tenant.isSuspended ? (
											<>
												<p className='text-danger'>
													{translator('TenantDetail-TenantIsSuspended')}{' '}
													<span>
														{translator('TenantDetail-ReasonForSuspension')}{' '}
														{tenant.suspensionNote
															? tenant.suspensionNote
															: translator('TenantDetail-NoSuspensionReason')}
													</span>
												</p>
												<button
													onClick={handleSuspend}
													class='btn btn-danger btn-block'>
													{translator('TenantDetail-CancelSuspension')}
												</button>
											</>
										) : (
											<button
												onClick={() => setShowSuspensionModal(true)}
												class='btn btn-danger btn-block'>
												{translator('TenantDetail-Suspend')}
											</button>
										)
									) : null}

									<hr />
									{tenant.isDeleted ? (
										<>
											{' '}
											<label>
												{' '}
												{translator('TenantDetail-SubjectIsDeactivated')}{' '}
												{dateHelper.formatUtcToDate(tenant.lastUpdated)}
											</label>
											<button
												onClick={() => setShowActivationModal(true)}
												class='btn btn-secondary btn-block'>
												{translator('TenantDetail-Activate')}
											</button>
											<hr />
										</>
									) : (
										''
									)}
									
									<button
												onClick={() => setShowFiscalModal(true)}
												class='btn btn-secondary btn-block'>
												{translator('TenantDetail-Fiscalize')}
											</button>
								</div>
							)}
						</div>
					)}
				</div>
				<LogoUpdate
					show={showLogoUpdate}
					tenantId={id}
					handleHide={handleHideLogoModal}
					setUpdate={setUpdate}
				/>
				<LogoDelete
					showDeleteLogo={showDeleteLogo}
					handleHideDeleteLogo={handleHideDeleteLogo}
					tenantId={id}
					setUpdate={setUpdate}
					centered
				/>
				<Modal
					show={showSuspensionModal}
					backdrop='static'
					keyboard={false}
					centered>
					<Modal.Header>
						<Modal.Title>
							{translator('TenantDetail-SuspensionModal-Title')}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className='form-group'>
							<p style={{ fontSize: '20px' }}>
								{' '}
								{translator('TenantDetail-SuspensionModal-Text')}
							</p>
							<label>
								{translator('TenantDetail-SuspensionModal-ReasonOfSuspension')}
							</label>
							<textarea
								name='suspensionNote'
								rows='3'
								id='textArea'
								type='text'
								className='form-control'
								value={tenant.suspensionNote}
								onChange={handleInputChange}
								ref={register({
									maxLength: 250,
								})}
							/>
							{errors.suspensionNote &&
								errors.suspensionNote.type === 'maxLength' && (
									<p className='text-danger'>
										{translator('ValidationMsg-MaxLength250')}
									</p>
								)}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							onClick={() => setShowSuspensionModal(false)}
							type='button'
							className='btn btn-secondary'>
							{translator('General-Close')}
						</button>
						<button
							onClick={handleSuspend}
							type='button'
							className='btn btn-danger'>
							{translator('TenantDetail-SuspensionModal-Suspend')}
						</button>
					</Modal.Footer>
				</Modal>

				<Modal
					show={showActivationModal}
					backdrop='static'
					keyboard={false}
					centered>
					<Modal.Header>
						<Modal.Title>
							{translator('TenantDetail-TenantActivation')}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{translator('TenantDetail-ModalText-TenantActivation')}
					</Modal.Body>
					<Modal.Footer>
						<button
							onClick={() => setShowActivationModal(false)}
							type='button'
							className='btn btn-secondary'>
							{translator('General-Close')}
						</button>
						<button
							onClick={handleActivate}
							type='button'
							className='btn btn-primary'>
							{translator('TenantDetail-ActivateBtn')}
						</button>
					</Modal.Footer>
				</Modal>

				<Modal
					show={showFiscalModal}
					backdrop='static'
					keyboard={false}
					centered>
					<Modal.Header>
						<Modal.Title>
							{translator('TenantDetail-TenantFiscal')}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{translator('TenantDetail-ModalText-Fiscalization')}
					</Modal.Body>
					<Modal.Footer>
						<button
							onClick={() => setShowFiscalModal(false)}
							type='button'
							className='btn btn-secondary'>
							{translator('General-Close')}
						</button>
						<button
							onClick={handleFiscal}
							type='button'
							className='btn btn-primary'>
							{translator('TenantDetail-FiscalBtn')}
						</button>
					</Modal.Footer>
				</Modal>					
				<div className='col-lg-9 border-left'>
					{!isLoading && (
						<Tabs
							id='tabs'
							activeKey={key}
							onSelect={k => {
								setKey(k);
								updateLocTab(k);
							}}
							variant='tabs'>
							<Tab
								eventKey='users'
								title={translator('Tenant-TenantDetail-NavTitle-Users')}
								tabClassName='mob-tabs'>
								<UsersTab
									url={`${apiUrl}/tenant/${id}/users`}
									tenantId={null}
								/>
							</Tab>
							<Tab
								eventKey='stores'
								title={translator('Tenant-TenantDetail-NavTitle-Stores')}
								tabClassName='mob-tabs'>
								<StoresTab url={`${apiUrl}/Store/search`} tenantId={id} />
							</Tab>
							<Tab
								eventKey='devices'
								title={translator('Tenant-TenantDetail-NavTitle-Devices')}
								tabClassName='mob-tabs'>
								<PosTab url={`${apiUrl}/Tenant/${id}/pos`} />
							</Tab>
							<Tab
								eventKey='certificates'
								title={translator('Tenant-TenantDetail-NavTitle-Certificates')}
								tabClassName='mob-tabs'>
								<CertificateTab tenantId={id} />
							</Tab>
							<Tab
								eventKey='partners'
								title={translator('Tenant-TenantDetail-NavTitle-Partners')}
								tabClassName='mob-tabs'>
								<PartnersTab tenantId={id} />
							</Tab>
							<Tab
								eventKey='itemGroup'
								title={translator('Tenant-TenantDetail-NavTitle-ItemGroup')}
								tabClassName='mob-tabs'>
								<ItemGroupTab tenantId={id} />
							</Tab>
							<Tab
								eventKey='paymentMethod'
								title={translator(
									'Tenant-TenantDetail-NavTitle-PaymentMethods',
								)}
								tabClassName='mob-tabs'>
								<PaymentMethodTab tenantId={id} />
							</Tab>
							<Tab
								eventKey='settings'
								title={translator('Tenant-TenantDetail-NavTitle-Settings')}
								tabClassName='mob-tabs'>
								<TeantSettingTab tenantId={id} />
							</Tab>
						</Tabs>
					)}
				</div>
			</div>
			<div
				className='container-fluid'
				style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<button className='btn btn-outline-secondary' onClick={handleCancel}>
					{translator('Btn-Back')}
				</button>
			</div>
		</CardWrap>
	);
};

export default TenantDetail;
